import React, { FC } from 'react'
import styles from 'styles/components/tag.module.scss'
import classNames from 'classnames'

type Props = {
  color: 'blue' | 'green' | 'black' | 'grey' | 'orange' | 'red'
  shape?: 'ellipse' | 'square'
  size?: 'medium' | 'large'
  startIcon?: string
  tagName: string
}
// TODO そのうち BlackTag, BlueTag, GreenTag, GreyTag, RedTag を置き換える
const Tag: FC<Props> = (props) => {
  const { color, shape, size, startIcon, tagName } = props

  return (
    <span
      className={classNames({
        [styles.tag_green]: color === 'green',
        [styles.tag_orange]: color === 'orange',
        [styles.tag_red]: color === 'red',
        [styles.tag_blue]: color === 'blue',
        [styles.tag_black]: color === 'black',
        [styles.tag_grey]: color === 'grey',
        [styles.tag__ellipse]: shape === 'ellipse',
        [styles.tag_large]: size === 'large',
        [styles.tag__icon]: startIcon,
      })}
    >
      {startIcon && <img src={startIcon} alt={tagName} />}
      {tagName}
    </span>
  )
}

export default Tag
